/**
 * @class RouteMissingError
 * @since 1.0.0
 */
export class RouteMissingError extends Error {
    /**
     * @constructor
     * @since 1.0.0
     */
    constructor(name) {
        super('Route has not been defined: ' + name);
    }
}
